"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgNearBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Flusso",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "___where-offline-geo2",
    transform: "translate(-20.000000, -296.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone/near/white",
    transform: "translate(20.500000, 296.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: "9",
    cy: "13.5",
    rx: "4.5",
    ry: "2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: "9",
    cy: "13.5",
    rx: "8.5",
    ry: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "evenodd",
    cx: "9",
    cy: "2",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,9.5 L11.5,9.5 L11.5,7 C11.5,5.61928813 10.3807119,4.5 9,4.5 C7.61928813,4.5 6.5,5.61928813 6.5,7 L6.5,9.5 Z",
    id: "Rectangle",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60990195,9.5 L8.40990195,13.5 C9.06802741,13.5 9.38968051,13.5 9.59009805,13.5 C9.69692155,12.9658825 9.81267529,12.3871138 10.390098,9.5 L7.60990195,9.5 Z",
    id: "Rectangle",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
var _default = SvgNearBy;
exports["default"] = _default;